export function integrationActionItems() {
    return [/*{ key: "edit", label: "Edit" },*/ { key: "delete", label: "Delete" }];
}